import React from 'react';
import { Typography } from '@primitives';
import Form from './Components/Form';
function SelfServeStateResetter() {
  return (
    <div className="flex items-center justify-center h-[80vh] ">
      <div className="bg-[var(--bg-primary) shadow-lg flex flex-col rounded-lg w-[458px]  p-[24px]">
        <Typography variant={'h2'}>Agent Auto Logout </Typography>
        <div>
          <Form />
        </div>
      </div>
    </div>
  );
}

export default SelfServeStateResetter;
